import { Trash2 } from "lucide-react";
import { useState } from "react";

import { Confirm } from "@/components/admin/confirm";
import { Button } from "@/components/ui/button";

export interface DeleteIconButtonProps {
  /** Translation key or text, used as the button label and the dialog title. */
  label: string;
  onConfirm: () => Promise<void> | void;
}

/** Trash icon that asks for confirmation before deleting. */
export const DeleteIconButton = ({
  label,
  onConfirm,
}: DeleteIconButtonProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  return (
    <>
      <Button
        type="button"
        variant="ghost"
        size="icon"
        className="size-7 shrink-0 text-muted-foreground hover:text-destructive"
        aria-label={label}
        title={label}
        onClick={(event) => {
          event.stopPropagation();
          setIsOpen(true);
        }}
      >
        <Trash2 className="size-4" />
      </Button>
      <Confirm
        isOpen={isOpen}
        loading={isLoading}
        title={label}
        content="ra.message.are_you_sure"
        onClose={() => setIsOpen(false)}
        onConfirm={async () => {
          setIsLoading(true);
          try {
            await onConfirm();
            setIsOpen(false);
          } finally {
            setIsLoading(false);
          }
        }}
      />
    </>
  );
};
